import "./module/userAgentChecker.js"
import "./module/responsive.js"

import Swiper from "swiper";
var mySwiper = new Swiper ('.main__slide', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: true,
    speed: 3000,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})

var mySwiper01 = new Swiper ('.banner__slide', {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    speed: 1500,
    autoplay: {
        delay: 1000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        414: {
          slidesPerView: 2,
          spaceBetween: 10,
        }
    }
})